import { useEffect, useState, createContext, useContext } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Landing from "./pages/Landing";
import AdminPage from "./pages/AdminPage";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";
import LegalPage from "./pages/LegalPage";

export const LangContext = createContext({ lang: "pl", setLang: () => {} });
export const useLang = () => useContext(LangContext);

function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    window.__lenis = lenis;
    return () => { cancelAnimationFrame(raf); lenis.destroy(); window.__lenis = null; };
  }, []);
  return null;
}

function App() {
  const [lang, setLang] = useState("pl");
  return (
    <LangContext.Provider value={{ lang, setLang }}>
      <div className="App grain">
        <BrowserRouter>
          <SmoothScroll />
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/info/:slug" element={<LegalPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LangContext.Provider>
  );
}

export default App;
